<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { showAGBCheckbox } from '@/helper'

  export default {
    name: 'RegisterForm',
    data() {
      return {
        errors: {},
        fieldErros: {},
        pages: {},
        isTermsAccepted: false,
      }
    },
    computed: {
      ...mapFields('registration', [
        'registrationData.invoiceAddress.email',
        'registrationData.invoiceAddress.password',
        'activeStep',
      ]),
      ...mapState('registration', ['pending']),
      ...mapState('pages', [ 'legal_pages' ]),
      ...mapState('auth', ['settings']),
    },
    mounted() {
      this.getLegalPages().then(_ => {
        this.setPages()
      })
    },
    methods: {
      ...mapActions('registration', ['registerAccount']),
      ...mapActions('pages', [ 'getLegalPages' ]),
      onSubmit() {
        this.errors = this.fieldErros = {}
        this.$refs.form.validate().then(_ => {
          if (!this.$refs.form.flags.valid || this.$refs.form.flags.invalid) {
            // exit with general error if form isn't valid
            this.fieldErros = this.$t('errors.messages.required_fields')
            return false
          }
          this.registerAccount().then(_ => {
            this.activeStep++
            this.$router.push({ name: 'registration' })
          }).catch(errors => {
            if (errors) {
              this.errors = errors.response.data
            }
          })
        })
      },
      setPages() {
        Object.entries(this.legal_pages).forEach(page => {
          this.pages[page[0]] = this.$router.resolve({ name: 'page', params: { id: page[1].page_id } }).href || ''
        })
      },
      showAGBCheckbox,
    },
  }
</script>
